<template>
    <div id="dateInput" class="g-date-input">
        <PInputMask
            :class="`input ${invertido ? 'invertido' : 'input-padrao'}`"
            mask="99/99/9999"
            v-model="valorTexto"
            slotChar="dd/mm/aaaa"
            v-on:blur="atualizaData"
            :placeholder="placeholderinput"
            :disabled="this.disabled"
            @keyup.space="getAno"
            />
        <PCalendar
            id="icon"
            v-model="valorData"
            dateFormat="dd/mm/yyyy"
            :class="`g-calendario-botao ${invertido ? 'botao-esquerda' : 'botao-direita'}`"
            :showIcon="true"
            :disabled="this.disabled"
            :minDate="DataMinima" 
            :maxDate="DataMaxima"
        />
    </div>
</template>

<script>
import gDateinput from './g-date-input.js'
export default gDateinput
</script>

<style scoped>

.input {
    width: v-bind('largurainput');
    height: v-bind('alturainput');
}

.invertido{
    border-top-left-radius: 0px ;
    border-bottom-left-radius:0px ;
}
.input-padrao{
    border-top-right-radius: 0px ;
    border-bottom-right-radius:0px ;
}

.g-date-input{
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: v-bind('BtnInvertido');
}

:deep(.g-calendario-botao .p-inputtext) {
    display: none;
}

:deep(.p-button.p-button-icon-only){
    width: v-bind('tamanhobotao');
    color: #929292;
    background-color: #D6D6D6;
    border: none;
    box-shadow: none;
}

:deep(.p-button.p-button-icon-only:hover){
    color: #929292;
    background-color: #D6D6D6;
    border: none;
    box-shadow: none;
}

:deep(.botao-esquerda .p-button.p-button-icon-only) {
    transform: scaleX(-1);
}

:deep(.botao-direita .p-button.p-button-icon-only) {
    transform: scaleX(1);
}

</style>
